import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login/login.component';
import { ForgotpasswordComponent } from './components/forgot-reset-password/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/forgot-reset-password/reset-password/reset-password.component';
import { RequestQuoteComponent } from './components/request-quote/request-quote.component';
import { SystemAdminComponent } from './components/system-admin/system-admin.component';
import { CompanyComponent } from './components/system-admin/company/company.component';
import { AuthGuard } from './auth/auth.guard';
import { QuoteComponent } from './components/quote/quote.component';
import { SystemSettingsComponent } from './components/system-admin/system-settings/system-settings.component';
import { SystemAdminDashboardComponent } from './components/system-admin/system-admin-dashboard/system-admin-dashboard.component';
import { UserComponent } from './components/system-admin/user/user.component';
import { BranchComponent } from './components/system-admin/branch/branch.component';
import { AddUserComponent } from './components/system-admin/user/add-user/add-user.component';
import { AddCompanyComponent } from './components/system-admin/company/add-company/add-company.component';
import { AddBranchComponent } from './components/system-admin/branch/add-branch/add-branch.component';
import { CompanyListComponent } from './components/system-admin/company/company-list/company-list.component';
import { UserListComponent } from './components/system-admin/user/user-list/user-list.component';
import { BranchListComponent } from './components/system-admin/branch/branch-list/branch-list.component';
import { PolicyDocumentsComponent } from './components/policy-documents/policy-documents.component';
import { UnsavedFormChangesGuard } from './guards/unsaved-form-changes.guard';
import { loginEntryGuard } from './auth/login-entry.guard';

export const routes: Routes = [   
    { path : 'login', component:LoginComponent, canActivate: [loginEntryGuard]},
    { path : 'forgot-password', component:ForgotpasswordComponent},
    { path : 'reset-password', component:ResetPasswordComponent},
    { path : 'create-password', component:ResetPasswordComponent},
    { path : 'request-quote', component:RequestQuoteComponent,canActivate:[AuthGuard]},
    { path: 'request-quote/:id', component: RequestQuoteComponent ,canActivate:[AuthGuard]},  // with id
    { path : 'quote',component:QuoteComponent,canActivate:[AuthGuard],data: { role: [1, 2] }},
    { path : 'system-admin', component:SystemAdminComponent,canActivate:[AuthGuard],data: { role: [3] }},
    { path : 'system-admin-dashboard', component:SystemAdminDashboardComponent,canActivate:[AuthGuard],data: { role: [3] }, 
      children: [
        {path: 'system-settings', component: SystemSettingsComponent},
        {path: 'company', component: CompanyComponent,
          children:[
            {path:'company-list', component:CompanyListComponent},
            {path:'add-company', component:AddCompanyComponent,canDeactivate:[UnsavedFormChangesGuard]}, 
            {path:'edit-company/:companyId', component:AddCompanyComponent,canDeactivate:[UnsavedFormChangesGuard]},   
            { path: '', redirectTo: 'company-list', pathMatch: 'full' },         
          ]
        },
        {path: 'user', component: UserComponent,
          children:[
            {path:'user-list', component:UserListComponent},
            {path:'add-user', component:AddUserComponent,canDeactivate:[UnsavedFormChangesGuard]},
            {path:'edit-user/:userId', component:AddUserComponent,canDeactivate:[UnsavedFormChangesGuard]},   
            { path: '', redirectTo: 'user-list', pathMatch: 'full' },
          ]
        },
        {path: 'branch', component: BranchComponent,
          children:[
            {path:'branch-list', component:BranchListComponent},
            {path:'add-branch', component:AddBranchComponent,canDeactivate:[UnsavedFormChangesGuard]},
            {path:'edit-branch/:branchId', component:AddBranchComponent,canDeactivate:[UnsavedFormChangesGuard]},   
            { path: '', redirectTo: 'branch-list', pathMatch: 'full' },         

          ]
        },
        { path: '', redirectTo: 'company', pathMatch: 'full' },
      ]
    },
    {path: 'policy-document', component: PolicyDocumentsComponent},
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: '**', redirectTo: '/login' } 
  ];
  
